<template>
    <b-card class="subordinates-card">
        <template #header>
            <div
                class="d-flex justify-content-between card-module-header pb-1"
                v-b-toggle="`Collapse-${subordinate.id}`"
            >
                <div class="d-flex flex-row">
                    <avatar class="mr-2" :size="35" :src="subordinate.picture" :username="subordinate.name" />
                    <div class="mt-1">
                        <p class="user-name text-primary">
                            {{ subordinate.name }}
                        </p>
                    </div>
                </div>
                <span class="arrow-color mt-2">
                    <i :class="['fas fa-md', visible ? 'fa-angle-up' : 'fa-angle-down']"></i>
                </span>
            </div>
        </template>
        <b-collapse v-model="visible" :id="`Collapse-${subordinate.id}`">
            <networks :user="subordinate" @loaded="$emit('loaded')" />
        </b-collapse>
    </b-card>
</template>

<script>
import Networks from '../../../list/Networks'
import Avatar from 'vue-avatar'

export default {
    components: {
        Networks,
        Avatar,
    },
    props: {
        subordinate: {
            type: Object,
            required: true,
        },
        toggleAll: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            visible: true,
        }
    },
    watch: {
        toggleAll() {
            this.visible = this.toggleAll
        },
    },
}
</script>

<style lang="sass" scoped>
.user-name
    font-weight: bold
    font-size: 16px

.subordinates-card
    border-bottom: none
    .card-body
        padding: 0

.card-header
    padding: 0

.arrow-color
    color: #009ADA;
    &:hover
        color: #007BAE;

.card-module-header
    padding: 0.75rem 1.25rem
    cursor: pointer
</style>
